/**
 * Minimal per-story data used by the client bundle on /results: just the link
 * target and the visible label for the "Browse Every Story" navigation list.
 *
 * Generated from src/lib/results-stories.ts — run `bun scripts/generate-results-story-links.ts`
 * after adding or renaming a story. src/lib/results-story-links.test.ts fails
 * if this file drifts from the full story catalog.
 */
export type StoryLink = { slug: string; name: string; tagline?: string };

export const storyLinks: StoryLink[] = [
  { slug: "paula-c-1", name: "Paula C." },
  { slug: "an-anonymous-virginia-bariatric-patient-2", name: "Anonymous" },
  { slug: "an-anonymous-patient-who-got-her-groove-back-3", name: "Anonymous", tagline: "Talk about getting your groove back!" },
  { slug: "an-anonymous-transformation-4", name: "Anonymous" },
  { slug: "another-amazing-anonymous-transformation-5", name: "Anonymous" },
  { slug: "an-anonymous-patient-s-one-year-change-6", name: "Anonymous" },
  { slug: "m-m-7", name: "M. M." },
  { slug: "l-s-8", name: "L. S." },
  { slug: "jdb-9", name: "JDB" },
  { slug: "jack-a-10", name: "Jack A." },
  { slug: "shelly-t-11", name: "Shelly T." },
  { slug: "alfred-and-patricia-crews-12", name: "Alfred and Patricia Crews" },
  { slug: "amanda-g-13", name: "Amanda G." },
  { slug: "amanda-g-another-view-14", name: "Amanda G. (again)" },
  { slug: "amanda-r-15", name: "Amanda R." },
  { slug: "ban-h-16", name: "Ban H." },
  { slug: "chad-beckhert-17", name: "Chad Beckhert" },
  { slug: "cynthia-welgoss-18", name: "Cynthia Welgoss" },
  { slug: "e-m-and-his-mom-19", name: "E.M. and his mom" },
  { slug: "a-halloween-costume-transformation-20", name: "Happy Halloween!" },
  { slug: "jason-lamprey-21", name: "Jason Lamprey" },
  { slug: "kristina-and-sean-22", name: "Kristina and Sean", tagline: "Power couple!" },
  { slug: "lori-m-23", name: "Lori M." },
  { slug: "lorraine-w-24", name: "Lorraine W." },
  { slug: "lucretia-dennington-25", name: "Lucretia Dennington" },
  { slug: "michael-t-26", name: "Michael T." },
  { slug: "mr-g-27", name: "Mr. G", tagline: "Forgot his before. Se la vie..." },
  { slug: "shona-gardner-28", name: "Shona Gardner" },
  { slug: "tawana-b-29", name: "Tawana B." },
  { slug: "tiffany-w-30", name: "Tiffany W." },
  { slug: "k-campos-31", name: "K. Campos" },
  { slug: "k-s-32", name: "K. S." },
  { slug: "an-anonymous-virginia-bariatric-weight-loss-surgery-patient-33", name: "Anonymous" },
  { slug: "an-anonymous-bariatric-surgery-patient-s-side-by-side-result-34", name: "Anonymous" },
  { slug: "an-anonymous-transformation-35", name: "Anonymous" },
  { slug: "shakeela-robinson-36", name: "Shakeela Robinson", tagline: "Way to go, Shakeela!" },
];

